import React from 'react';
import cn from 'classnames';
import { map } from 'lodash';
import { useIntl } from 'react-intl';
import { App } from '@gin-betting/core';

import { Toggler, Icon, SettingsDropdown } from 'components';
import useOddsStatisticSelect from './useOddsStatisticSelect';
import chevron from 'assets/svg/chevron.svg';
import percent from 'assets/svg/percentage.svg';
import globalMsg from 'messages';
import './oddsStatisticSelect.scss';

const OddsStatisticSelect: React.FC = () => {
    const {
        show,
        statisticView,
        handlerStatisticToggle,
        makeOnClick,
    } = useOddsStatisticSelect();
    const { formatMessage } = useIntl();

    const hint = formatMessage(globalMsg.oddsStatistic);

    const statisticViewMapping: { [K: string]: string } = {
        [App.OddStatisticView.MATCH]: formatMessage(globalMsg.byMatch),
        [App.OddStatisticView.MARKET]: formatMessage(globalMsg.byMarket),
    };

    return (
        <SettingsDropdown title={hint} glyph={percent} width={12} height={12}>
            <div styleName="options">
                <div styleName="option toggler">
                    <div styleName="toggler-text">
                        {formatMessage(globalMsg.show)}
                    </div>
                    <Toggler
                        onToggle={handlerStatisticToggle}
                        isOpened={show}
                        isDisabled={false}
                    />
                </div>
                {map(
                    statisticViewMapping,
                    (title, selected: App.OddStatisticView) => {
                        const isSelected = statisticView === selected;

                        return (
                            <div
                                key={title}
                                styleName={cn('list option', {
                                    'is-selected': isSelected,
                                })}
                                onClick={makeOnClick(selected)}
                            >
                                {isSelected && (
                                    <Icon styleName="icon" glyph={chevron} />
                                )}
                                {title}
                            </div>
                        );
                    }
                )}
            </div>
        </SettingsDropdown>
    );
};

export default OddsStatisticSelect;
